<template>
  <div class="columns is-multiline">
    <div class="column">
      <window title="Basics" height="100%">
        <div class="field">
          <b-switch>Default</b-switch>
        </div>
        <div class="field">
          <b-switch v-model="isSwitched">
            {{ isSwitched }}
          </b-switch>
        </div>
        <div class="field">
          <b-switch v-model="isSwitchedCustom" true-value="Yes" false-value="No">
            {{ isSwitchedCustom }}
          </b-switch>
        </div>
        <div class="field">
          <b-switch disabled>Disabled</b-switch>
        </div>
      </window>
    </div>
    <div class="column">
      <window title="Types" height="100%">
        <div class="field">
          <b-switch :value="true">
            Default
          </b-switch>
        </div>
        <div class="field">
          <b-switch :value="true" type="is-info">
            Info
          </b-switch>
        </div>
        <div class="field">
          <b-switch :value="true" type="is-success">
            Success
          </b-switch>
        </div>
        <div class="field">
          <b-switch :value="true" type="is-danger">
            Danger
          </b-switch>
        </div>
        <div class="field">
          <b-switch :value="true" type="is-warning">
            Warning
          </b-switch>
        </div>
      </window>
    </div>
    <div class="column">
      <window title="Sizes" height="100%">
        <div class="field">
          <b-switch size="is-small">Small</b-switch>
        </div>
        <div class="field">
          <b-switch>Default</b-switch>
        </div>
        <div class="field">
          <b-switch size="is-medium">Medium</b-switch>
        </div>
        <div class="field">
          <b-switch size="is-large">Large</b-switch>
        </div>
      </window>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSwitched: false,
      isSwitchedCustom: 'Yes',
    };
  },
};
</script>
